import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../store/actions/ModalAction";
import SendTipModal from "./SendTipModal";
import UnLockContent from "./UnLockContent";

import LowWalletBalanceModal from "../Modals/LowWalletBalanceModal";
import EndStreamModal from "../../components/Stream/Shared/EndStreamModal";
import SendTipStreamModal from "../../components/Stream/Shared/SendTipStreamModal";
import EditStreamDescription from "../../components/Stream/Shared/EditStreamDescription";

export const MODAL_CONSTANT = {
  SEND_TIP_MODAL: "SEND_TIP_MODAL",
  UNLOCK_POST_MODAL: "UNLOCK_POST_MODAL",
  END_LIVE_STREAM_MODAL: "END_LIVE_STREAM_MODAL",
  SEND_TIP_STREAM_MODAL: "SEND_TIP_STREAM_MODAL",
  LOW_WALLET_BALANCE_MODAL: "LOW_WALLET_BALANCE_MODAL",
  EDIT_STREAM_DESCRIPTION_MODAL: "EDIT_STREAM_DESCRIPTION_MODAL"
};

const RootModal = () => {
  const dispatch = useDispatch();
  const modals = useSelector((state) => state.modals);

  useEffect(() => {
    return () => {
      handleCloseModal();
    };
  }, []);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  switch (modals.general.type) {
    case MODAL_CONSTANT.SEND_TIP_MODAL:
      return (
        <SendTipModal
          sendTip={modals.general.open}
          closeSendTipModal={handleCloseModal}
        />
      );
    case MODAL_CONSTANT.UNLOCK_POST_MODAL:
      return (
        <UnLockContent
          isOpen={modals.general.open}
          toggleModal={handleCloseModal}
        />
      );
    case MODAL_CONSTANT.END_LIVE_STREAM_MODAL:
      return (
        <EndStreamModal
          isOpen={modals.general.open}
          toggleModal={handleCloseModal}
        />
      );
    case MODAL_CONSTANT.EDIT_STREAM_DESCRIPTION_MODAL:
      return (
        <EditStreamDescription
          isOpen={modals.general.open}
          toggle={handleCloseModal}
        />
      );
    case MODAL_CONSTANT.SEND_TIP_STREAM_MODAL:
      return (
        <SendTipStreamModal
          isOpen={modals.general.open}
          toggleModal={handleCloseModal}
        />
      );
    case MODAL_CONSTANT.LOW_WALLET_BALANCE_MODAL:
      return (
        <LowWalletBalanceModal
          isOpen={modals.general.open}
          toggleModal={handleCloseModal}
        />
      );
    default:
      return <></>;
  }
};

export default RootModal;
